var map = {
	"./ArchitectureDesign.png": 583,
	"./ChaosEngineering.png": 177,
	"./Cloud-Native.png": 7113,
	"./CloudGovernance.png": 6225,
	"./Cluster-Assessment.png": 5429,
	"./Cost-OptimizedStorage.png": 9076,
	"./Developer&SRE.png": 6570,
	"./FinOpsStrategyAdvisory.png": 975,
	"./Full-StackSRE.png": 478,
	"./Intelligent-Cost-Monitoring.png": 6464,
	"./Inter-CloudPlatform.png": 997,
	"./Managed-Kubernetes.png": 6752,
	"./Migration&Modernization.png": 7875,
	"./MigrationCostAssessment.png": 2043,
	"./On-PremisestoPublicCloud.png": 4295,
	"./ProvenScale.png": 8700,
	"./RapidAlerting.png": 2394,
	"./SLOTracking.png": 1573,
	"./SeamlessMulti-Cloud.png": 1106,
	"./Security&Compliance.png": 7847,
	"./Training&Knowledge.png": 1512,
	"./VM-to-ContainerTransformation.png": 5436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8399;